import { Plus } from 'lucide-react';
import { Link } from 'react-router-dom';
import * as AccordionPrimitive from '@radix-ui/react-accordion';
import writingPoster from './images/writing-poster.png';
import podcasterPoster from './images/podcast-poster.png';
import businessPoster from './images/business-poster.png';
import designerPoster from './images/design-poster.png';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
} from 'components/ui/accordion';

const items = [
  {
    id: '1',
    title: 'AI tools for designers',
    image: designerPoster,
    link: '/designers',
  },
  {
    id: '2',
    title: 'AI tools for podcasters',
    image: podcasterPoster,
    link: '/podcaster',
  },
  {
    id: '3',
    title: 'AI tools for writers',
    image: writingPoster,
    link: '/writer',
  },
  {
    id: '4',
    title: 'AI tools for businesses',
    image: businessPoster,
    link: '/business',
  },
];

function AccordionComponent() {
  return (
    <div className="space-y-4 max-w-5xl mx-auto px-4 md:px-0">
      <Accordion
        collapsible
        className="w-full space-y-4 md:space-y-6"
        defaultValue="3"
        type="single"
      >
        {items.map((item) => (
          <AccordionItem
            key={item.id}
            className="rounded-lg shadow-none border-none bg-[#202020] px-4 md:px-6 py-2 md:py-3 data-[state=open]:bg-primary/50 data-[state=open]:px-2 md:data-[state=open]:px-3"
            value={item.id}
          >
            <AccordionPrimitive.Header className="flex">
              <AccordionPrimitive.Trigger className="flex flex-1 items-center text-white justify-between py-2 text-left text-xl md:text-2xl font-normal tracking-wide leading-6 transition-all [&>svg>path:last-child]:origin-center [&>svg>path:last-child]:transition-all [&>svg>path:last-child]:duration-200 [&[data-state=open]>svg>path:last-child]:rotate-90 [&[data-state=open]>svg>path:last-child]:opacity-0 [&[data-state=open]>svg]:rotate-180 [&[data-state=open]]:hidden">
                {item.title}
                <Plus
                  aria-hidden="true"
                  className="shrink-0 opacity-60 transition-transform duration-200"
                  size={24}
                  strokeWidth={2}
                />
              </AccordionPrimitive.Trigger>
            </AccordionPrimitive.Header>
            <AccordionContent className="text-muted-foreground p-0">
              <div className="bg-background rounded-2xl md:rounded-3xl"> 
                <img
                  alt={item.title}
                  src={item.image}
                  className="w-full h-auto"
                />     
              </div>
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}

const DreamSection = () => {
  return (
    <div className="bg-background-marketing py-16 md:py-28">
      <div className="text-text-primary text-center text-3xl sm:text-4xl md:text-[60px] tracking-wider font-semibold leading-tight md:leading-none mb-8 md:mb-16 px-4 md:px-0">
        If you can dream it,
        <br />
        you can Kreait it!
      </div>
      <AccordionComponent />
    </div>
  );
};

export default DreamSection;
